import { FC, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { Setting } from '../../types/constant/PagesPropsType';
import cancelPauseLinkClass from '../../assets/scss/SubscriptionDetail/CancelPauseLink.module.scss';
import { PauseConfirmModal } from '../PauseConfirmModal/PauseConfirmModal';
import { useUpdateSubscriptionStatus } from '../../hooks/use-update-subscription-status';
import { SubscriptionApiType } from '../../types/api/SubscriptionApiType';
import { PauseConfirmModalViewType } from '../../types/view/PauseConfirmModalViewType';
import { postMessageGtag } from '../../utils/trackClick';
import { SkipModalViewType } from '../../types/view/SkipModalViewType';

export const PauseLink: FC<{
  cancelPauseInfo: {};
  setting: Setting;
  subscription: SubscriptionApiType;
  loading: boolean;
  toggleLoading: React.Dispatch<React.SetStateAction<boolean>>;
  toggleSkipModal: React.Dispatch<React.SetStateAction<SkipModalViewType | null>>;
  onSwitchToRecommended: () => void;
  returnToPauseModal: boolean;
  setReturnToPauseModal: React.Dispatch<React.SetStateAction<boolean>>;
}> = ({
  cancelPauseInfo,
  setting,
  subscription,
  loading,
  toggleLoading,
  toggleSkipModal,
  onSwitchToRecommended,
  returnToPauseModal,
  setReturnToPauseModal,
}) => {
  const history = useHistory();
  const { pauseSubscription } = useUpdateSubscriptionStatus();

  // 停止確認モーダルのデータ
  const [pauseConfirmModal, setPauseConfirmModal] = useState<PauseConfirmModalViewType | null>(
    null
  );

  const clickPauseLinkHandler = () => {
    setPauseConfirmModal({
      clickSkipLinkFunc: () => {
        setPauseConfirmModal(null);
        toggleSkipModal({ isOpen: true });
      },
      thanksmilePoints,
      route: 'new',
    });
  };

  const [isOpen, setIsOpen] = useState(false);
  const toggleClass = () => {
    if (!isOpen) {
      // アコーディオンが開く分の高さ調整
      const height = document.querySelector('body')!.scrollHeight;
      setting.resize(height + 100);
    }
    setIsOpen(!isOpen);
  };

  // サンクスマイル
  const [thanksmilePoints, setThanksmilePoints] = useState('');
  useEffect(() => {
    if (!isOpen) return;

    window.parent.postMessage({ action: 'thanksmile' }, '*');

    const fetchThanksmile = (event: MessageEvent<any>) => {
      if (event.data.action && event.data.action === 'thanksmile') {
        setThanksmilePoints(event.data.points);
      }
    };

    window.addEventListener('message', fetchThanksmile);

    return () => window.removeEventListener('message', fetchThanksmile);
  }, [isOpen]);

  // returnToPauseModalが変更されたとき
  useEffect(() => {
    if (returnToPauseModal) {
      console.log('returnToPauseModal');
      // 停止モーダルを再表示
      setPauseConfirmModal({
        clickSkipLinkFunc: () => {
          setPauseConfirmModal(null);
          toggleSkipModal({ isOpen: true });
        },
        thanksmilePoints,
        route: 'new',
      });
      // フラグをリセット
      setReturnToPauseModal(false);
    }
  }, [returnToPauseModal]);

  let link = <></>;
  // 最低購入回数を満たしている場合のみリンクが有効になる
  if (cancelPauseInfo['canCancelPause']) {
    link = (
      <button
        className={cancelPauseLinkClass.pauseModalLink}
        onClick={() => {
          clickPauseLinkHandler();
          postMessageGtag('click_open_PausePage', 'detailSettings');
        }}
      >
        定期オトク便を停止する
      </button>
    );
  } else {
    link = (
      <p className={cancelPauseLinkClass.pauseGuidance}>
        ご案内：{cancelPauseInfo['minCycle'] + 1}回目のお届けから停止可能
      </p>
    );
  }

  return (
    <>
      <div
        className={`${cancelPauseLinkClass.changeContractStatus} ${
          isOpen ? cancelPauseLinkClass.changeContractStatusOpen : ''
        }`}
      >
        <button
          className={cancelPauseLinkClass.title}
          onClick={() => {
            toggleClass();
            postMessageGtag('click_open_SettingPause', 'detailSettings');
          }}
        >
          お届けを止める
          <span
            className={`${isOpen ? cancelPauseLinkClass.angleUp : cancelPauseLinkClass.angleDown}`}
          ></span>
        </button>
        <div className={`${isOpen ? cancelPauseLinkClass.open : cancelPauseLinkClass.closed}`}>
          {link}
        </div>
      </div>

      {/* 停止モーダル */}
      <PauseConfirmModal
        active={pauseConfirmModal !== null}
        closeFunc={() => setPauseConfirmModal(null)}
        pauseConfirmModal={pauseConfirmModal}
        clickSubmitFunc={() => {
          toggleLoading(true);
          pauseSubscription(
            setting,
            subscription!,
            () => {
              setPauseConfirmModal(null);
              window.parent.postMessage({ action: 'fixedBtnShow' }, '*');
              history.push('/');
            },
            () => {},
            () => {
              toggleLoading(false);
            }
          );
        }}
        onSwitchToRecommended={onSwitchToRecommended}
        loading={loading}
        setting={setting}
        subscription={subscription}
      />
    </>
  );
};
